import React, { useState, useEffect } from "react";

const LearnMore = () => {
    return (
        <div className="wrapper" style={{ paddingTop: '100px' }}>
            <h1 className="display-3 fw-bold">learn more about our frames</h1>

            <h2 className="px-0 fw-bold">Main Components</h2>
            <table className="table table-striped table-bordered mt-4">
                <thead>
                    <tr>
                        <th className="w-25">Component</th>
                        <th>What is it?</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="align-middle fw-bold">Frame Moulding</td>
                        <td className="align-middle">The outer frame that surrounds and enhances the artwork.</td>
                    </tr>
                    <tr>
                        <td className="align-middle fw-bold">Mat Board</td>
                        <td className="align-middle">A border that creates space between the artwork and glazing while improving presentation.</td>
                    </tr>
                    <tr>
                        <td className="align-middle fw-bold">Glazing</td>
                        <td className="align-middle">Glass or acrylic that protects the artwork from dust, damage, and UV exposure.</td>
                    </tr>
                    <tr>
                        <td className="align-middle fw-bold">Mounting & Backing</td>
                        <td className="align-middle">Materials that support and secure the artwork inside the frame.</td>
                    </tr>
                </tbody>
            </table>

            <div>
                <h2 className="px-0 fw-bold">Mat Board Options</h2>

                <h3 className="mt-4 fw-bold fs-3">Regular Mat Boards</h3>
                <ul>
                    <li>Great for decorative framing and general presentation</li>
                    <li>Commonly used for posters, prints, and everyday artwork.</li>
                    <li>Made from standard paper-based materials</li>
                    <li>Best for short to medium term displays</li>
                </ul>
                <h3 className="mt-4 fw-bold fs-3">Acid-Free / Conservation Mat Boards</h3>
                <ul>
                    <li>Designed to protect artwork and photographs long-term</li>
                    <li>Made with materials that reduce harmful acid migration</li>
                    <li>Helps prevent yellowing, fading, and paper deterioration</li>
                    <li>Recommended for photography, fine art, diplomas, and keepsakes</li>
                </ul>
            </div>

            <div>
                <h2 className="px-0 fw-bold">Acrylic (Plexiglass) Glazing Options</h2>

                <h3 className="mt-4 fw-bold fs-3">Regular Clear Acrylic</h3>
                <ul>
                    <li>Lightweight and safer than traditional glass</li>
                    <li>Provides basic protection against dust and handling</li>
                    <li>Great for posters, prints, and general décor.</li>
                </ul>
                <h3 className="mt-4 fw-bold fs-3">UV Protective Acrylic</h3>
                <ul>
                    <li>Filters harmful ultraviolet light that causes fading</li>
                    <li>Helps preserve artwork color and detail</li>
                    <li>Recommended for valuable artwork and photography</li>
                </ul>
                <h3 className="mt-4 fw-bold fs-3">Reflection Control Acrylic</h3>
                <ul>
                    <li>Reduces glare caused by lighting and windows</li>
                    <li>Improves visibility in bright environments</li>
                    <li>Ideal for offices, hallways, and well-lit rooms</li>
                </ul>

                <h3 className="mt-4 fw-bold fs-3">Museum / Gallery Grade Acrylic (PREMIUM)</h3>
                <ul>
                    <li>Exceptional optical clarity with minimal reflections</li>
                    <li>High UV protection for long-term preservation</li>
                    <li>Used by museums, galleries, and collectors</li>
                    <li className="fw-bold"> Please contact MyCustomFrame.com directly for pricing and availability</li>
                </ul>

            </div>

        </div>
    );
};

export default LearnMore;